/**
 * @module FE-CU33_アカウント管理カメラ画面
 */
import Header from '../../../components/header/Header.vue';
import PcPageTitle from '../../../components/pcPageTitle/PcPageTitle.vue';
import BreadCrumbList from '../../../components/breadCrumb/List.vue';
import ListPanel from '../../../components/listPanel/ListPanel.vue';
import MobileFooter from '../../../components/footer/MobileFooter.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import CONSTANTS from '../../../constants';

const PAGE_ID = 'FE-CU33';

export default {
  name: 'CameraAccountManagement',
  components: {
    Header,
    PcPageTitle,
    BreadCrumbList,
    ListPanel,
    MobileFooter,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU33アカウント管理カメラ画面.アカウント管理_カメラ'), // "アカウント管理 ( カメラ )",
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU33アカウント管理カメラ画面.C0001'),
      //"ユーザー様のご契約している、カメラ一覧が表示されます。各カメラ毎のユーザー管理、緊急連絡先の変更を行うことができます。",
      panelTitle: '',
      result: [],
      panelTitles: [],
      items: [],
      deleteActions: [],
      cameraListInfo: [],
      confirmDataList: [],
      authority: [],
      width: 0,
      takeoverFlg: false,
      userAuthorityFlg: false,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU33アカウント管理カメラ画面.アカウント管理_カメラ'), // "アカウント管理 ( カメラ )",
        hintText: vm.$vuetify.lang.t(
          '$vuetify.メッセージ一覧.FECU33アカウント管理カメラ画面.C0001'
        ),
        //"ユーザー様のご契約している、カメラ一覧が表示されます。各カメラ毎のユーザー管理、緊急連絡先の変更を行うことができます。",
        confirmDataList: [
          `${vm.$vuetify.lang.t(
            '$vuetify.FECU33アカウント管理カメラ画面.カメラ_ニックネーム'
          )}：リビングカメラ`,
          //"カメラ(ニックネーム)：リビングカメラ",
          `${vm.$vuetify.lang.t(
            '$vuetify.FECU33アカウント管理カメラ画面.デバイスID'
          )}：111122223333444455556666`,
          //"デバイスID：111122223333444455556666",
        ],
      };
    },
    /**
     * ヘッダーに戻るボタンを表示するか
     * @returns {boolean} ヘッダーに戻るボタンを表示するか
     * @description アプリから遷移した場合は戻るボタンを表示しない
     */
    displayBackButton() {
      return this.$mq === 'pc' ? true : !(this.$route.query.takeoverToken && this.$isBrowser);
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * カメラ削除API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    async cameraDelete(param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            this.callSaveMessageDialog();
          },
          (error) => {
            if (error.message.includes('400')) {
              this.callSaveErrorDialog();
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },

    /**
     * 削除ボタン押下時処理
     * 確認ダイアログを表示してカメラ削除APIを実行
     * @param {*} index 削除対象インデックス
     */
    async onPressDelete(index) {
      // const nickname = `カメラ(ニックネーム): ${this.cameraListInfo[index].cameraNickname}`;
      // const device = `デバイスID: ${this.cameraListInfo[index].deviceID}`;
      const nickname = {
        i18nKey: '$vuetify.FECU33アカウント管理カメラ画面.カメラ_ニックネーム',
        name: `: ${this.cameraListInfo[index].cameraNickname}`,
      };
      const device = {
        i18nKey: '$vuetify.FECU33アカウント管理カメラ画面.デバイスID',
        name: `: ${this.cameraListInfo[index].deviceID}`,
      };
      this.confirmDataList.push(nickname);
      this.confirmDataList.push(device);
      const result = await this.$agreementListDialog(
        '$vuetify.agreementDialog.確認',
        // "確認",
        this.confirmDataList,
        '$vuetify.メッセージ一覧.FECU33アカウント管理カメラ画面.C0002',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
        // "表示のカメラを削除します。\n\rよろしいでしょうか。",
        // "いいえ",
        // "はい"
      );
      if (result === true) {
        let param = '/api/cameraAccountManagement/delete';

        let queries = {
          token: sessionStorage.getItem('token'),
          terminalInfo: localStorage.getItem('terminalInfo')
            ? localStorage.getItem('terminalInfo')
            : '',
          deviceID: this.cameraListInfo[index].deviceID,
          modified: this.cameraListInfo[index].modified,
        };

        let method = 'post';
        await this.cameraDelete(param, queries, method);
        this.confirmDataList = [];
      } else {
        // キャンセル
        this.confirmDataList = [];
      }
    },
    /**
     * 削除エラーダイアログを表示
     */
    async callSaveErrorDialog() {
      await this.$errorDialog('$vuetify.メッセージ一覧.FECU33アカウント管理カメラ画面.E0001');
    },
    /**
     * 削除完了ダイアログを表示
     */
    async callSaveMessageDialog() {
      await this.$informationDialog(
        '$vuetify.メッセージ一覧.FECU33アカウント管理カメラ画面.C0003',
        true
      );
    },
    /**
     * ストアの画面タイプにカメラを設定
     * @param {*} deviceID デバイスID
     * @param {*} cameraUserType カメラユーザー種別
     */
    setStateCamera(deviceID, cameraUserType) {
      this.$store.state.currentDisplayType = 2;
      this.$store.state.deviceID = deviceID;
      this.$store.state.cameraUserType = cameraUserType;
    },
    /**
     * 初期表示API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    getCameraAccountManagementList: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            if (method === 'get' || method === 'post' || method === 'put') {
              apiData = response.data;

              // サンプルデータ
              // apiData = {
              //   contentsInfo: {
              //     cameraListInfo: [
              //       {
              //         cameraNickname: "リビングカメラ",
              //         cameraUserType: 1, // 1：メインユーザー、２：サブユーザー
              //         userManagementAuthority: true, // ユーザー管理権限あり、なし
              //         emergencyContactAuthority: false, // 緊急連絡先権限あり、なし
              //         customerNumber: "51-12345677", // お客様番号
              //         securityDestinationName: "警備 太郎 宅", // 警備先名称
              //         deviceID: "01234-56789", // カメラデバイスID
              //         districtSplitNumber: "0001", // 地区番号
              //         districtSplitName: "リビング", // 地区名
              //         usagePlanId: 100, // 利用プランID
              //         modified: "", // 更新日
              //       },
              //       {
              //         cameraNickname: "車庫カメラ",
              //         cameraUserType: 2, // 1：メインユーザー、２：サブユーザー
              //         userManagementAuthority: true, // ユーザー管理権限あり、なし
              //         emergencyContactAuthority: true, // 緊急連絡先権限あり、なし
              //         customerNumber: "511234567", // お客様番号
              //         securityDestinationName: "佐藤 太郎 宅", // 警備先名称
              //         deviceID: "01234-56789", // カメラデバイスID
              //         districtSplitNumber: "0002", // 地区番号
              //         districtSplitName: "キッチン", // 地区名
              //         usagePlanId: 101, // 利用プランID
              //         modified: "", // 更新日
              //       },
              //       {
              //         cameraNickname: "庭カメラ",
              //         cameraUserType: 1, // 1：メインユーザー、２：サブユーザー
              //         userManagementAuthority: true, // ユーザー管理権限あり、なし
              //         emergencyContactAuthority: true, // 緊急連絡先権限あり、なし
              //         customerNumber: "511234559", // お客様番号
              //         securityDestinationName: "佐藤 英子 宅", // 警備先名称
              //         deviceID: "01234-78901", // カメラデバイスID
              //         districtSplitNumber: "0002", // 地区番号
              //         districtSplitName: "キッチン", // 地区名
              //         usagePlan: 102, // 利用プランID
              //         modified: "", // 更新日
              //       },
              //     ],
              //   },
              // };

              //------------ 以下整形処理 ------------------------

              // ヘッダー・フッターカメラ表示フラグ（Navのカメラボタンも表示制御する。）
              if (!this.userAuthorityFlg || apiData.contentsInfo.cameraListInfo.length == 0) {
                this.$store.state.disableCamera = true;
              } else {
                this.$store.state.disableCamera = false;
              }

              // 入力データのソート処理
              let sortedArray = apiData.contentsInfo.cameraListInfo.slice();
              sortedArray = sortedArray.sort(function (a, b) {
                // カメラユーザー種別でソート
                // a.cameraUserTypeが2(サブユーザー)、b.cameraUserTypeが1(メインユーザー)のとき、-1を返すのでaが前に
                if (a.cameraUserType !== b.cameraUserType) {
                  return a.cameraUserType - b.cameraUserType;
                }
                // お客様番号でソート
                if (a.customerNumber !== b.customerNumber) {
                  if (!a.customerNumber && b.customerNumber) return 1; // aがブランクの時はbが前に
                  if (a.customerNumber && !b.customerNumber) return -1; // bがブランクの時はaが前に
                  return Number(a.customerNumber) - Number(b.customerNumber);
                }
                // 地区番号でソート
                if (a.districtSplitNumber !== b.districtSplitNumber) {
                  if (!a.districtSplitNumber && b.districtSplitNumber) return 1; // aがブランクの時はbが前に
                  if (a.districtSplitNumber && !b.districtSplitNumber) return -1; // bがブランクの時はaが前に
                  return Number(a.districtSplitNumber) - Number(b.districtSplitNumber);
                }
                // デバイスIDでソート
                if (a.deviceID !== b.deviceID) {
                  const aUpper = a.deviceID.toUpperCase();
                  const bUpper = b.deviceID.toUpperCase();
                  return aUpper < bUpper ? -1 : 1;
                }
              });
              apiData.contentsInfo.cameraListInfo = sortedArray;
              this.cameraListInfo = apiData.contentsInfo.cameraListInfo;

              // 表示データdisplayItemsの作成
              apiData?.contentsInfo?.cameraListInfo.map((item) => {
                let displayItems = [];

                let auth = {};
                // 権限とユーザーを紐づける
                this.authority.map((au) => {
                  if (
                    au.cameraUserType == item?.cameraUserType &&
                    au.customerNumber == item?.customerNumber &&
                    au.deviceID == item?.deviceID &&
                    au.districtSplitNumber == item?.districtSplitNumber
                  ) {
                    auth = au;
                  }
                });

                // ユーザー管理
                if (
                  item?.userManagementAuthority &&
                  (!Object.keys(auth).length || auth.management)
                ) {
                  displayItems = [
                    ...displayItems,
                    {
                      id: 1,
                      title: '$vuetify.FECU32アカウント管理対象地区画面.ユーザー管理', //"ユーザー管理",
                      text: '$vuetify.FECU32アカウント管理対象地区画面.ユーザー管理変更ボタン', //"変更",
                      // title: "ユーザー管理",
                      // text: "変更",
                      isVuetifyKey: true,
                      url: '/userManagement',
                      linkClickAction: () =>
                        this.setStateCamera(item.deviceID, item.cameraUserType),
                    },
                  ];
                }

                // 緊急連絡先権限をセット
                if (
                  item.emergencyContactAuthority &&
                  auth?.contact &&
                  (item.usagePlanId === CONSTANTS.CAMERA_USAGE_PLAN.ONLINE_MONITORING_PLAN ||
                    item.usagePlanId ===
                      CONSTANTS.CAMERA_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN)
                ) {
                  displayItems = [
                    ...displayItems,
                    {
                      id: 2,
                      title: '$vuetify.FECU32アカウント管理対象地区画面.緊急連絡先', //"緊急連絡先",
                      text: '$vuetify.FECU32アカウント管理対象地区画面.緊急連絡策変更ボタン', //"変更",
                      isVuetifyKey: true,
                      url: '/emergencyContact',
                      linkClickAction: () => {
                        this.$store.state.emergencyContactNumber = 0;
                        this.setStateCamera(item.deviceID, item.cameraUserType);
                      },
                    },
                  ];
                }

                const panelTitle = {
                  place: `${item.cameraNickname} -  `,
                  type: `${
                    item.cameraUserType === 1
                      ? '$vuetify.FECU33アカウント管理カメラ画面.ユーザー権限データ.メインユーザー'
                      : '$vuetify.FECU33アカウント管理カメラ画面.ユーザー権限データ.サブユーザー'
                  }`,
                  typeIsBefore: false,
                };
                this.panelTitles = [...this.panelTitles, panelTitle];

                // 各種情報をセット
                displayItems = [
                  ...displayItems,
                  {
                    id: 3,
                    title: '$vuetify.FECU32アカウント管理対象地区画面.お客様番号', // "お客様番号",
                    text: item?.customerNumber,
                    url: null,
                  },
                  {
                    id: 4,
                    title: '$vuetify.FECU32アカウント管理対象地区画面.警備先名', //"警備先名",
                    text: item?.securityDestinationName,
                    url: null,
                  },
                  {
                    id: 5,
                    title: '$vuetify.FECU32アカウント管理対象地区画面.地区番号', //"地区番号",
                    text: item?.districtSplitNumber,
                    url: null,
                  },
                  {
                    id: 6,
                    title: '$vuetify.FECU32アカウント管理対象地区画面.地区名', // "地区名",
                    text: item?.districtSplitName,
                    url: null,
                  },
                  {
                    id: 7,
                    title: '$vuetify.FECU32アカウント管理対象地区画面.デバイスID', //"デバイスID",
                    text: item?.deviceID,
                    url: null,
                  },
                ];

                displayItems.map((item) => {
                  if (item.id === 5) {
                    if (item.text === '    ') {
                      item.text = '$vuetify.FECU33アカウント管理カメラ画面.メイン地区';
                    }
                  }
                });

                displayItems = displayItems.filter((item) => {
                  if ([3, 4, 5, 6].includes(item.id) && (item.text === null || item.text === '')) {
                    return;
                  } else {
                    return item;
                  }
                });

                // 削除ボタンの表示切り替え
                let deleteItem = {};
                if (item.cameraUserType === 1 && item.deletableFlag) {
                  deleteItem = {
                    isDelete: true,
                    action: () => {}, // 削除ボタンの動作
                  };
                } else {
                  deleteItem = {
                    isDelete: false,
                    // action: () => {},
                  };
                }
                this.deleteActions = [...this.deleteActions, deleteItem];

                this.result = [
                  ...this.result,
                  { panelTitles: this.panelTitles, items: displayItems },
                ];
              });
            }
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      // console.log("APP_CU3301>>>", apiData);
      return apiData;
    },
    /**
     * ユーザー権限一覧取得API実行処理
     */
    async APP_CU9916() {
      let param = '/api/common/getRoleList';
      // let param = "post";

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
      };

      let method = 'post';
      let apiData = '';
      this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          async (response /* eslint-disable-line */) => {
            apiData = response.data;

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfoList: {
            //       customerNumber: "sendCustomerNumber",
            //       districtSplitNumber: "sendCustomerNumber",
            //       displayDistrictUserType: 1,
            //       userAuthority: {
            //         securityOperation: true,
            //         rushOrder: true,
            //         notificationHistory: true,
            //         deviceContorol: true,
            //         contact: true,
            //         nicknameSetting: true,
            //         IDCardKeyInfoSetting: true,
            //         watchOverInfoDeliverySetting: true,
            //         lockUpCheck: true,
            //         targetAtHomeSetting: true,
            //         userManagement: true,
            //         emergencyContact: true,
            //       },
            //     },
            //     cameraInfoList: {
            //       customerNumber: "customerNumber",
            //       districtSplitNumber: "districtSplitNumber",
            //       deviceID: "deviceID",
            //       cameraUserType: 0,
            //       userAuthority: {
            //         anticrimeCameraVideos: false,
            //         rushOrder: false,
            //         notificationHistory: false,
            //         contact: false,
            //         nicknameSetting: false,
            //         userManagement: false,
            //         emergencyContact: false,
            //       },
            //     },
            //   },
            // };

            if (apiData.contentsInfo.displayDistrictInfoList.length != 0) {
              this.$store.state.isTopHomeSecurityActive = true;
            }

            if (apiData.contentsInfo.cameraInfoList.length != 0) {
              this.$store.state.isTopCameraActive = true;
            }

            for (let i = 0; i < apiData.contentsInfo.cameraInfoList.length; i++) {
              let auth = {
                cameraUserType: '',
                customerNumber: '',
                deviceID: '',
                districtSplitNumber: '',
                management: false,
                contact: false,
              };
              if (
                apiData.contentsInfo.cameraInfoList[i].userAuthority.anticrimeCameraVideos ==
                  false &&
                apiData.contentsInfo.cameraInfoList[i].userAuthority.rushOrder == false &&
                apiData.contentsInfo.cameraInfoList[i].userAuthority.notificationHistory == false &&
                apiData.contentsInfo.cameraInfoList[i].userAuthority.contact == false &&
                apiData.contentsInfo.cameraInfoList[i].userAuthority.nicknameSetting == false &&
                apiData.contentsInfo.cameraInfoList[i].userAuthority.userManagement == false &&
                apiData.contentsInfo.cameraInfoList[i].userAuthority.emergencyContact == false
              ) {
                // 全てfalseである場合、画面項目No.18、No.19を非表示にする。
              } else {
                // 一つでもtrueがある場合、画面項目No.18、No.19を表示する。
                auth.cameraUserType = apiData.contentsInfo.cameraInfoList[i].cameraUserType;
                auth.customerNumber = apiData.contentsInfo.cameraInfoList[i].customerNumber;
                auth.deviceID = apiData.contentsInfo.cameraInfoList[i].deviceID;
                auth.districtSplitNumber =
                  apiData.contentsInfo.cameraInfoList[i].districtSplitNumber;
                auth.management =
                  apiData.contentsInfo.cameraInfoList[i].userAuthority.userManagement;
                auth.contact =
                  apiData.contentsInfo.cameraInfoList[i].userAuthority.emergencyContact;
                if (!this.userAuthorityFlg) this.userAuthorityFlg = true;
              }
              this.authority[i] = auth;
            }

            let param = '/api/cameraAccountManagement/init';
            // let param = "post";

            let queries = {
              token: sessionStorage.getItem('token'),
              terminalInfo: localStorage.getItem('terminalInfo')
                ? localStorage.getItem('terminalInfo')
                : '',
            };

            let method = 'post';
            // APP_CU3301
            await this.getCameraAccountManagementList(param, queries, method);
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        );
      // console.log("APP_CU9916>>>", apiData);
    },
    /**
     * 継続ログイン認証API実行処理
     */
    async APP_CU9913() {
      let param = '/api/common/continueLogin';
      let queries = {
        takeOverToken: this.$route.query.takeoverToken,
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
      };

      let method = 'post';
      let apiData = '';

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          async (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // apiData = {
            //   contentsInfo:{
            //     loginResult: 0   // 0: ログイン成功 | 1: 2段階認証が必要 | 2: ログイン失敗
            //   },
            //   token: "string"
            // }
            this.$store.commit('setTakeoverTokenFlg', { takeoverTokenFlg: true });
            switch (apiData.contentsInfo.loginResult) {
              case 0: {
                this.$store.commit('setIsLoggedIn', { isLoggedIn: true });
                sessionStorage.setItem('token', apiData.token);

                // 権限取得APP_CU9916
                await this.APP_CU9916();
                if (this.$store.getters['isLoggedIn']) {
                  await this.$refs.header.APP_CU0201();
                }
                break;
              }
              case 1: {
                let handoverToken = apiData.token;
                this.$router.push({
                  path: '/twoStepAuthentication',
                  query: {
                    handoverToken: handoverToken,
                    targetPage: '/cameraAccountManagement',
                  },
                });
                break;
              }
              case 2: {
                this.$_abnormality(500);
                break;
              }
              default: {
                this.$_abnormality(500);
                break;
              }
            }
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    router: function (url) {
      this.$router.replace({
        path: url,
      });
    },
    closeDialog() {
      this.continueDialog = false;
      this.errorDialog = false;
    },
    /**
     * 画面サイズ(幅)変更処理
     * @param {*} width 画面サイズ(幅)
     */
    changeItemLabelWidth(width) {
      this.width = width;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // アプリから遷移時orリロード時
      if (from.path == '/') {
        vm.takeoverFlg = true;
        next();
      } else {
        next();
      }
    });
  },
  async mounted() {
    if (this.$route.query.takeoverToken && this.$isBrowser && this.takeoverFlg) {
      this.$store.commit('setTakeoverTokenFlg', { takeoverTokenFlg: false });
    }
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    // 継続ログイン認証APP_CU9913
    if (this.$route.query.takeoverToken && this.$isBrowser && !this.$store.state.takeoverTokenFlg) {
      await this.APP_CU9913();
    } else {
      // 権限取得APP_CU9916
      this.$store.commit('setTakeoverTokenFlg', { takeoverTokenFlg: true });
      await this.APP_CU9916();
      if (this.$store.getters['isLoggedIn']) {
        await this.$refs.header.APP_CU0201();
      }
    }

    this.$watch('$mq', function () {
      this.changeItemLabelWidth(
        this.$mq === 'pc'
          ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC
          : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP
      );
    });

    //画面サイズの計算が上記なので、全部おわってから表示/警備ユニットとの通信もないのでローディングマークも無視。
    this.isShowPage = true;
  },
};
